import { Component, OnInit, Input } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AuthenticatedContext } from 'src/app/models/authenticated-context';
import { SmoochService } from 'src/app/services/smooch.service';
import { combineLatest, switchMap } from 'rxjs/operators';
import { TwitterUser } from './twitter-user';
import { TwitterChannel } from './twitter-channel';
import { MatSnackBar } from '@angular/material/snack-bar';

type TwitterIntegration = {
  user: TwitterUser;
  channel: TwitterChannel;
}

@Component({
  selector: 'app-twitter-setup',
  templateUrl: './twitter-setup.component.html',
  styleUrls: ['./twitter-setup.component.scss']
})
export class TwitterSetupComponent implements OnInit {

  @Input('context') context$: Observable<AuthenticatedContext>;

  integration$: Observable<TwitterIntegration>;

  constructor(
    private _smoochService: SmoochService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.integration$ = this.context$.pipe(
      combineLatest(this._smoochService.integrations$),
      switchMap(([context, channels]) => {
        let twitterChannels = channels as TwitterChannel[];
        let user = context.user as TwitterUser;
        return of({
          user,
          channel: twitterChannels.find(channel => channel.type === 'twitter' && channel.userId === user.profile.id)
        });
      })
    );
  }

  toggle(integration: TwitterIntegration) {
    if (integration.channel) {
      this._smoochService.deleteIntegration(integration.channel._id)
        .subscribe(response => {
          this._snackBar.open(`Deleted Twitter DM integration with ${integration.user.profile.displayName}.`);
        }, error => {
          const errorMessage = `Failed to delete Twitter DM integration with ${integration.user.profile.displayName}: ${error.error.description}.`;
          this._snackBar.open(errorMessage);
          console.error(errorMessage, error);
        });
    } else {
      this._smoochService.createIntegration('twitter', {
        settings: {
          accessTokenKey: integration.user.token,
          accessTokenSecret: integration.user.tokenSecret
        }
      }).subscribe(response => {
        this._snackBar.open(`Created Twitter DM integration with ${integration.user.profile.displayName}.`);
      }, error => {
        const errorMessage = `Failed to create Twitter DM integration with ${integration.user.profile.displayName}: ${error.error.description}.`;
        this._snackBar.open(errorMessage);
        console.error(errorMessage, error);
      });
    }
  }
}
